export const LAST_UPDATED = "April 21, 2025";

export const SUPPORT_EMAIL = "support@dualio.ai";
